import { Injectable, signal } from '@angular/core';

import { MenuItem } from 'app/services/navbar/user-navigation';

@Injectable()
export class NavbarService {
    private itemsSignal = signal<MenuItem[]>([]);
    items = this.itemsSignal.asReadonly();

    setItems(items: MenuItem[]): void {
        this.itemsSignal.set(items);
    }
}
